const networkIcons = {
  1: require('@images/icons/ethereum-eth-logo.svg'), //ethereum
  56: require('@images/icons/bnb-bnb-logo.svg'), // Binance Smart Chain (BSC)
  97: require('@images/icons/bnb-bnb-logo.svg'), // Binance Smart Chain Testnet (BSC Testnet)
  143: require('@images/icons/monad-logo.svg'), // Monad Mainnet
  4663: require('@images/icons/robinhood-chain-logo.svg'), // Robinhood Chain
  8453: require('@images/icons/base-logo-in-blue.svg') // Base
};

const currencyIcons = {
  4663: require('@images/icons/ethereum-robinhood-logo.svg')
};

export default function getNetworkIcon(networkId) {
  return networkIcons[networkId] || require('@images/icons/ethereum-eth-logo.svg'); // 默认图标URL
}

export function getCurrencyIcon(networkId) {
  return currencyIcons[networkId] || getNetworkIcon(networkId);
}
